import './right-rows.scss';

/**
 * version    1.0
 * class      <type> (RightRows)
 * classdesc  Component that manage the right-rows section
 */
export class RightRows {}
